import React, { useState, useEffect } from 'react';
import styles from './dwn-style.module.css'; 
import { useNavigate, useSearchParams } from 'react-router-dom';



 

const SignInScreen = () => {


   const [id,setID] = useState("")
   const [pin, setPin] = useState("")
   const [message, setMessage] = useState("")
   const navigate = useNavigate();


  const inputChangeID = (value) =>{

        setMessage("")
        setID(value)

  }



  const inputChangePin = (value) =>{

        setMessage("")
        setPin(value)
    
  }
  
  const getID = (code, meeting_id, role) =>{


    const body = {"code":code}

    let connectionString = "https://app.digitalwellnessnurse.com" //https://app.digitalwellnessnurse.com  http://localhost:2001
    fetch(connectionString+'/api/portal/getPIDfromCode', {
        method: 'POST',
        headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    }).then((response) => {
       if(response.status == 200){
        return response.json();
       }
      
            
    }
 ).catch((error) => {
    console.log(error)
}).then((json) => {
    navigate('/Meeting', { state: {pid: json.pid, uid:json.uid, meeting_id:meeting_id, role:role} });

  })


}
  
  const verifyAppCode = (code, meeting_id, role) =>{


    const body = {"code":code}

    let connectionString = "https://app.digitalwellnessnurse.com" //https://app.digitalwellnessnurse.com  http://localhost:2001
    fetch(connectionString+'/api/portal/appcode', {
        method: 'POST',
        headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
        credentials: "include",
    }).then((response) => {
        if(response.status == 200)
        {
            getID(code, meeting_id, role)

        }
        else if(response.status == 401) {
            setMessage("Incorrect code, try again.")
        }

        else if(response.status == 452 ){
            setMessage("Code has expired, sign in again.")
        }

        else if(response.status == 500 ){
            setMessage("DWN unavailble contact jerome@mahi-labs")
        }
            
    }
    ).catch((error) => {
        console.log(error)
    })


   }
   const authenticate = async () => {
    if (id !== "" && pin !== "") {
      let date = new Date();
  
      const body = { username: id, password: pin, date: date };
      const connectionString = "https://app.digitalwellnessnurse.com"; //https://app.digitalwellnessnurse.com  http://localhost:2001
  
      try {
        // Step 1: Authenticate the user
        const response = await fetch(`${connectionString}/api/portal/signin`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        });
  
        if (response.ok) {
          // Step 2: Retrieve the UID using the PID
          const uidResponse = await fetch(`${connectionString}/api/portal/getUIDfromPID`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ pid: id }), // Assuming `id` is the PID
          });
  
          if (uidResponse.ok) {
            const uidData = await uidResponse.json();
            const { uid } = uidData;
  
            // Step 3: Navigate with the PID and UID
            navigate('/Authenticate', { state: { pid: id, uid: uid } });
          } else {
            console.error("Failed to retrieve UID:", uidResponse.status);
            setMessage("Unable to retrieve user information. Please try again.");
          }
        } else {
          if (response.status === 401) {
            setMessage("Incorrect ID or PIN. Please try again");
          } else if (response.status === 400) {
            setMessage("Services are down. Contact jerome@mahi-labs.com if the problem continues.");
          } else {
            console.error("Unexpected error:", response.status);
            setMessage("An unexpected error occurred. Please try again.");
          }
        }
      } catch (error) {
        console.error("Error during authentication:", error);
        setMessage("An unexpected error occurred. Please try again.");
      }
    } else {
      setMessage("Please enter ID and PIN");
    }
  };
  



   const [searchParams] = useSearchParams();
   const appCode = searchParams.get('appCode');
   const meeting_id = searchParams.get('mid');
   const role = searchParams.get('role');

   if(appCode == null || meeting_id == null || role == null){
    return (
        <div className={styles.center}>
            <p><img className={styles.dwnLogo} src="dwn.png" alt="DWN Logo" /></p>
            <div className={styles.loginContainer}>
                <div className={styles.loginItems}>
                   <p><span className={styles.loginMessage}>{message}</span></p>
                    <p className={styles.logintText}>ID</p>
                    <input
                        className={styles.loginInput}
                        type="text"
                        onChange={e => inputChangeID(e.target.value)}
                        
                    />
                     <p className={styles.logintText}>PIN</p>
                    <input
                        className={styles.loginInput}
                        type="password"
                        onChange={e => inputChangePin(e.target.value)}
                    />
                    <p>
                         <div className={styles.loginBttnContainer}>
                            <button onClick={authenticate} type="button" className={styles.loginBttn}><span className={styles.loginBttnLabel}>Sign in</span></button>
                         </div>
                    </p>
                        
                </div>
            </div>
        </div>
        
    );
   } 
   else{
    verifyAppCode(appCode,meeting_id, role)
   }
};
 
export default SignInScreen;